export enum ResultPhotoTab {
  EQUIPMENTS = 'equipments',
  DAMAGES = 'damages',
  VEHICULES = 'vehicules',
}

export enum ResultModalStep {
  SELECT_ENTITY = 'modalSelectEntity',
  CAPTURE_VIDEO = 'modalCaptureVideo',
  CONFIRM_CAPTURE = 'modalConfirmCapture',
  UPLOAD_IMAGE = 'modalUploadImage',
  MODERATE = 'modalModerate',
}
